import * as React from 'react';
import { CommonStyles } from '../../../../common/styles/CommonStyles';

export interface BarProps {
  min: number;
  max: number;
  value: number;
  style?: React.CSSProperties;
}

export function Bar(props: BarProps) {
  return props.max - props.min > 0 ? (
    <div className="container" style={{ height: '100%', ...props.style, position: 'relative' }}>
      <div
        className="content"
        style={{
          position: 'absolute',
          width: (props.value / (props.max - props.min)) * 100 + '%',
          backgroundColor: CommonStyles.Colors.Grey218,
        }}
      ></div>
    </div>
  ) : null;
}
